export default __webpack_public_path__ + "static/media/ICONO_COTIZACION.cbab3ce5.svg";